<template>
	<div class="box">
		<div class="null-page" v-show="yes"></div>
		
		<el-card class="box-card" style="height:730px;">
			<div slot="header" class="clearfix">
				<span>编辑账户</span>
			</div>
		
			<div v-loading="loading">
				<el-form :model="formData" :rules="rules" ref="ruleForm" label-width="80px">
					<el-form-item label="户名" prop="realname">
						<el-input disabled v-model="formData.realname" placeholder="请输入户名" class="ns-len-input"></el-input>
					</el-form-item>
		
					<el-form-item label="手机" prop="mobile">
						<el-input disabled  v-model="formData.mobile" autocomplete="off" placeholder="请输入手机号" maxlength="11" class="ns-len-input"></el-input>
					</el-form-item>
		
					<el-form-item label="账号类型" prop="withdraw_type" v-if="0">
						<el-select v-model="formData.withdraw_type" placeholder="请选择账号类型">
							<el-option v-for="(value, key) in transferType" :key="key" :label="value" :value="key" :disabled="key == 'wechatpay'"></el-option>
						</el-select>
					</el-form-item>
		
					<el-form-item label="开户行" prop="branch_bank_name" v-if="formData.withdraw_type == 'bank'">
						 <el-input @input="showlist($event)" v-model="formData.branch_bank_name" autocomplete="off" placeholder="请输入银行名称" maxlength="50" class="ns-len-input"></el-input>  
						 <div class="banklikelist" v-if="showwait">查询中</div>
						 <div class="banklikelist" v-if="listbank.length>0">
						 	<ul> 
						 	 <li v-for="(bankvalue, bankkey) in listbank" :key="bankkey" @click="setbranchno(bankvalue.openBranch,bankvalue.bankName)">{{bankvalue.bankName}}</li>
						 	  
						 	 </ul>
						 </div>
					</el-form-item>
					
					<el-form-item label="银行账号" prop="bank_account" v-if="formData.withdraw_type != 'wechatpay' && formData.withdraw_type">
						<el-input v-model="formData.bank_account" autocomplete="off" placeholder="请输入提现账号" maxlength="30" class="ns-len-input"></el-input>
					</el-form-item>
		
					<el-form-item>
						<el-button size="medium" type="primary" @click="saveAccount('ruleForm')">保存</el-button>
					</el-form-item>
				</el-form>
			</div>
		</el-card>
	</div>
</template>

<script>
	import { transferType, accountDetail,accountAuthDetail, saveAccount,likebankList } from "@/api/member/member"
	export default {
		name: "account_edit",
	    components: {},
	    data () {
			let self = this
			var isMobile = (rule, value, callback) => {
			    if (!value) {
			        return callback(new Error("手机号不能为空"))
			    } else {
			        const reg = /^1[3|4|5|6|7|8|9][0-9]{9}$/
			
			        if (reg.test(value)) {
			            callback()
			        } else {
			            callback(new Error("请输入正确的手机号"))
			        }
			    }
			}
	        return {
				formData: {
					id: '',
					realname: '',
					mobile: '',
					withdraw_type: 'bank',
					bank_account: '',
					branch_bank_name: '',
					bank_code: ''
				},
				flag: false, //防重复标识
				payList: [],
				listbank:[],
				showwait:false,
				curOpenBranch:'',
				loading: true,
				index: 0,
				transferType: [],
				rules: {
					realname: [{ required: true, message: "请输入真实姓名", trigger: "blur" }],
					mobile: [{ required: true, validator: isMobile, trigger: "blur" }],
					withdraw_type: [{ required: true, message: '请选择账号类型', trigger: 'change' }],
					branch_bank_name: [{ required: true, message: "请输入银行名称", trigger: "blur" }],
					bank_account: [{ required: true, message: "请输入提现账号", trigger: "blur" }],
				},
				yes: true
	        }
	    },
	    created() {
			this.formData.id = this.$route.query.id
			this.getTransferType();
			this.getAuthDetail();
			if (this.formData.id) {
				this.getAccountDetail(this.formData.id)
			}
	    },
		mounted() {
			let self = this;
			setTimeout(function() {
				self.yes = false
			}, 300)
		},
	    methods: {
			showlist(v){
				  this.listbank = []; 
				if(v.length>5){ 
				    this.showwait=true;
					likebankList({keyword:v}).then(res => {
						this.listbank = res.data; 
						if(this.listbank.length>0){
							this.showwait=false;
						}
				        
						//console.log(".............",JSON.stringify(res.data))
						 
					}).catch(err => {
						 
							this.loading = false
						 
					})
				}else{
					this.listbank = []; 
					 
				}
			},
			setbranchno(v,n){
				this.curOpenBranch=v;
				this.formData.branch_bank_name=n;
				this.listbank = []; 
			},
			/**
			 * 获取转账方式
			 */
			getTransferType() {
				transferType().then(res => {
					this.transferType = res.data;
					
					if (!this.formData.id) { // id为空，即添加时在此结束加载
						this.loading = false
					}
				}).catch(err => {
					if (!this.formData.id) {
						this.loading = false
					}
				})
			},
			getAuthDetail() {
				accountAuthDetail({}).then(res => {
					if (res.code == 0 && res.data) {
						this.formData.realname = res.data.auth_card_hand;
						this.formData.mobile = res.data.auth_card_no; 
					}
					this.loading = false
				}).catch(err => {
					this.loading = false
				})
			},
			/**
			 * 获取账户详情（编辑）
			 */
			getAccountDetail(id) {
				accountDetail({id: this.formData.id}).then(res => {
					if (res.code == 0 && res.data) {
						this.formData.realname = res.data.realname;
						this.formData.mobile = res.data.mobile;
						this.formData.bank_account = res.data.bank_account;
						this.formData.branch_bank_name = res.data.branch_bank_name;
						this.formData.bank_code = res.data.bank_code;
						this.formData.withdraw_type = res.data.withdraw_type;
						this.curOpenBranch=res.data.openBranch;
					}
					this.loading = false
				}).catch(err => {
					this.loading = false
				})
			},
			/**
			 * 保存
			 */
			saveAccount(formName) {
				this.$refs[formName].validate(valid => {
				    if (valid) {
				        var data = {
							id: this.formData.id,
							realname: this.formData.realname,
							mobile: this.formData.mobile,
							withdraw_type: this.formData.withdraw_type,
							bank_account: this.formData.bank_account,
							branch_bank_name: this.formData.branch_bank_name,
							bank_code: this.formData.bank_code,
							openBranch:this.curOpenBranch
				        }
				console.log("....................",JSON.stringify(data))
				        data.url = "add"
				        if (this.formData.id) {
				            data.url = "edit"
				        }
						
				        if (this.flag) return
				        this.flag = true
				
				        saveAccount(data)
				            .then(res => {
				                if (res.code == 0) {
				                    this.$router.push({ path: "/member/account_list" })
				                } else {
				                    this.flag = false
				                    this.$message({ message: res.message, type: "warning" })
				                }
				            })
				            .catch(err => {
				                this.flag = false
				                this.$message.error(err.message)
				            })
				    } else {
				        return false
				    }
				})
			}
		}
	}
</script>

<style lang="scss" scoped>
	.box {
		width: 100%;
		position: relative; 
	}
	
	.null-page {
		width: 100%;
		height: 730px;
		background-color: #FFFFFF;
		position: absolute;
		top: 0;
		left: 0;
		z-index: 9;
	}
	
	.el-card.is-always-shadow,
	.el-card.is-hover-shadow:focus,
	.el-card.is-hover-shadow:hover {
	    box-shadow: unset;
	}
	
	.el-card {
	    border: 0;
	}
	
	.ns-len-input {
	    width: 350px;
	}
	
	.el-select {
	    margin-right: 10px;
	}
	.banklikelist{ 
		background-color:#f1f1f1;
		border:solid 1px #f2f2f2;
		padding:10px;
		position: absolute;
		z-index:999;
	}
	.banklikelist ul li{
		cursor:pointer;
	}
</style>
